import * as blobUtil                             from "blob-util";
import { toast }                                 from "react-toastify";
import { b64DecodeUnicode, objectToQueryParams } from "../utils/dataUtils";

export const ohifKosViewerUrlDebugModes = {
  full   : "full",
  partial: "partial",
  none   : "none"
};



export const authenticateOhif = async (ohifConfig) => {
  const {
          ohifAuthUsername,
          ohifAuthUsernameArg,
          ohifAuthPasswd,
          ohifAuthPasswdArg,
          ohifAuthUrl
        } = ohifConfig;
  
  const headers = new Headers();
  // headers.set('Accept', 'application/json');
  headers.set("Content-Type", "application/json");
  
  return new Promise(async (resolve, reject) => {
    if (!ohifAuthUrl || !ohifAuthUsername || !ohifAuthPasswd) {
      resolve(undefined);
    } else {
      console.log('fetch auth')
      fetch(ohifAuthUrl, {
        method: "POST",
        headers,
        body  : JSON.stringify({
          [ohifAuthUsernameArg]: ohifAuthUsername,
          [ohifAuthPasswdArg]  : ohifAuthPasswd
        })
      }).then(response => response.text()).then(data => resolve(data)).catch(e => {
        toast("Une erreur s'est produite",
          {
            type     : "error",
            autoClose: 2000
          });
        console.error(e);
        reject(e);
      });
    }
  });
};

export const generateOhifHeaders = async (config, structId, defaultPacsId, sessionId, pscTokenBearer) => {
  const {
          hasPscTokenBearer,
          hasAuthTokenBearer,
          structIdHeaderName,
          pacsIdHeaderName,
          sessionIdHeaderName,
          
          ohifAuthUsername,
          ohifAuthUsernameArg,
          ohifAuthPasswd,
          ohifAuthPasswdArg,
          ohifAuthUrl
        } = config;
  
  const token = await authenticateOhif({
    ohifAuthUsername,
    ohifAuthUsernameArg,
    ohifAuthPasswd,
    ohifAuthPasswdArg,
    ohifAuthUrl
  });
  
  const headers = new Headers();
  headers.set("Accept", "application/json");
  
  if (hasPscTokenBearer && pscTokenBearer) {
    headers.set("Authorization", `Bearer ${pscTokenBearer}`);
  } else if (hasAuthTokenBearer && token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  
  if (structIdHeaderName) {
    headers.set(structIdHeaderName, structId);
  }
  if (sessionIdHeaderName) {
    headers.set(sessionIdHeaderName, sessionId);
  }
  if (pacsIdHeaderName) {
    headers.set(pacsIdHeaderName, defaultPacsId);
  }
  
  return headers;
};

export const generateOhifUrl = (ohifConfig, studyInstanceUid, serieInstanceUid) => {
  const
    {
      rootUrl,
      studyPath,
      seriesPath,
      requestParams,
      debugUrl
    } = ohifConfig;
  
  if (rootUrl) {
    let url = rootUrl;
    if (studyInstanceUid && studyPath) {
      url = `${url}${studyPath}${studyInstanceUid}`;
    }
    if (serieInstanceUid && seriesPath) {
      url = `${url}/${seriesPath}${serieInstanceUid}`;
    }
    
    if (requestParams) {
      try {
        const params = JSON.parse(requestParams);
        params.forEach((param, index) => {
          const separator = index === 0 ? "?" : "&";
          
          url = `${url}${separator}${param.key}=${param.value}`;
        });
      } catch (e) {
        toast("Une erreur s'est produite",
          {
            type     : "error",
            autoClose: 2000
          });
        console.error(e);
      }
    }
    
    return url;
  }
  
  if (debugUrl) {
    return debugUrl;
  }
  
  return undefined;
};

export const getSeriesDescFromSummary = (description = "") => {
  const lines    = description.split("\r\n");
  let seriesDesc = {};
  lines.forEach(line => {
    if (line.startsWith("Série-")) {
      const regex = /Série-(?<instanceUid>[\d.]+)\s:\s(?<modality>.*)\s@\s(?<laterality>.*)\s:\s(?<desc>.*)/;
      const
        {
          groups: {
            instanceUid,
            modality,
            laterality,
            desc
          }
        }         = line.match(regex) || {};
      
      seriesDesc[instanceUid] = { modality, laterality, desc };
    }
  });
  
  return seriesDesc;
};

const getValue = (dicomNode) => b64DecodeUnicode(dicomNode.s_dataInBase64);

export const getKosSummary = (dicomContent = {}) => {
  const { RawStructure = [] } = dicomContent;
  const contentSequence       = RawStructure.find(i => i.s_tag === "(0040,a730)");
  if (contentSequence && contentSequence.Items && contentSequence.Items.length > 0) {
    return contentSequence.Items.reduce((text, item) => {
      if (item.Items && item.Items.length > 0) {
        const conceptNameCodeSequence = item.Items.find(j => j.s_tag === "(0040,a043)");
        
        if (conceptNameCodeSequence) {
          const relationShipType = item.Items.find(j => j.s_tag === "(0040,a010)");
          const valueType        = item.Items.find(j => j.s_tag === "(0040,a040)");
          
          if (getValue(relationShipType) === "CONTAINS" && getValue(valueType) === "TEXT") {
            const textValue = item.Items.find(j => j.s_tag === "(0040,a160)");
            
            if (textValue) {
              return getValue(textValue);
            }
          }
        }
      }
      
      return text;
    }, "");
  }
  
  return "";
};

export const fetchPacsList = async ({
  ohifConfig,
  structId,
  pscTokenBearer
}) => {
  
  const {
          ohifGetPacsListRootUrl,
          ohifGetPacsListPSCTokenBearer,
          ohifGetPacsListStructIdNatHeaderName,
          ohifGetPacsListRequestParams,
          ohifGetPacsListAuthTokenBearer,
          ohifGetPacsListSessionIdHeaderName,
          
          defaultPacsId,
          ohifSessionId,
          
          ohifAuthUsername,
          ohifAuthUsernameArg,
          ohifAuthPasswd,
          ohifAuthPasswdArg,
          ohifAuthUrl
        } = ohifConfig;
  
  let url = generateOhifUrl(
    {
      rootUrl      : ohifGetPacsListRootUrl,
      requestParams: ohifGetPacsListRequestParams
    }
  );
  
  const headers = await generateOhifHeaders(
    {
      hasPscTokenBearer  : ohifGetPacsListPSCTokenBearer,
      hasAuthTokenBearer : ohifGetPacsListAuthTokenBearer,
      structIdHeaderName : ohifGetPacsListStructIdNatHeaderName,
      sessionIdHeaderName: ohifGetPacsListSessionIdHeaderName,
      
      ohifAuthUsername,
      ohifAuthUsernameArg,
      ohifAuthPasswd,
      ohifAuthPasswdArg,
      ohifAuthUrl
    },
    structId,
    defaultPacsId,
    ohifSessionId,
    pscTokenBearer
  );
  
  return fetch(
    url,
    {
      method: "GET",
      headers
    }
  );
};

export const transferToPacs = async ({
  ohifConfig,
  kosContent,
  s_struct_IdNat,
  pscTokenBearer,
  studyInstanceUid,
  seriesInstanceUid
}) => {
  const {
          ohifTransferToPacsRootUrl,
          ohifTransferToPacsStudyPath,
          ohifTransferToPacsSeriesPath,
          ohifTransferToPacsPSCTokenBearer,
          ohifTransferToPacsPacsIdHeaderName,
          ohifTransferToPacsSessionIdHeaderName,
          ohifTransferToPacsStructIdNatHeaderName,
          ohifTransferToPacsRequestParams,
          defaultPacsId,
          ohifTransferToPacsAuthTokenBearer,
          ohifSessionId,
          
          ohifAuthUsername,
          ohifAuthUsernameArg,
          ohifAuthPasswd,
          ohifAuthPasswdArg,
          ohifAuthUrl
        } = ohifConfig;
  
  let url      = generateOhifUrl(
    {
      rootUrl      : ohifTransferToPacsRootUrl,
      studyPath    : ohifTransferToPacsStudyPath,
      seriesPath   : ohifTransferToPacsSeriesPath,
      requestParams: ohifTransferToPacsRequestParams
    },
    studyInstanceUid,
    seriesInstanceUid
  );
  let formData = new FormData();
  const blob   = blobUtil.base64StringToBlob(kosContent, "application/dicom");
  formData.append("kos[]", blob, `${studyInstanceUid}.dcm`);
  
  // Do not force Content-Type header, the browser has to put it itself
  const headers = await generateOhifHeaders(
    {
      hasPscTokenBearer  : ohifTransferToPacsPSCTokenBearer,
      hasAuthTokenBearer : ohifTransferToPacsAuthTokenBearer,
      structIdHeaderName : ohifTransferToPacsStructIdNatHeaderName,
      sessionIdHeaderName: ohifTransferToPacsSessionIdHeaderName,
      pacsIdHeaderName   : ohifTransferToPacsPacsIdHeaderName,
      
      ohifAuthUsername,
      ohifAuthUsernameArg,
      ohifAuthPasswd,
      ohifAuthPasswdArg,
      ohifAuthUrl
    },
    s_struct_IdNat,
    defaultPacsId,
    ohifSessionId,
    pscTokenBearer
  );
  
  return fetch(
    url,
    {
      method: "POST",
      headers,
      body  : formData
    }
  );
};

export const getPacsTransferStatus = async ({
  ohifConfig,
  s_struct_IdNat,
  pscTokenBearer,
  transferId
}) => {
  const {
          ohifTransferToPacsStatusRootUrl,
          ohifTransferToPacsStatusPSCTokenBearer,
          ohifTransferToPacsStatusStructIdNatHeaderName,
          ohifTransferToPacsStatusSessionIdHeaderName,
          ohifTransferToPacsStatusPacsIdHeaderName,
          ohifTransferToPacsStatusTransferIdArgName,
          ohifTransferToPacsStatusRequestParams,
          defaultPacsId,
          ohifTransferToPacsStatusAuthTokenBearer,
          ohifSessionId,
          
          ohifAuthUsername,
          ohifAuthUsernameArg,
          ohifAuthPasswd,
          ohifAuthPasswdArg,
          ohifAuthUrl
        } = ohifConfig;
  
  let url = generateOhifUrl(
    {
      rootUrl      : ohifTransferToPacsStatusRootUrl,
      requestParams: ohifTransferToPacsStatusRequestParams
    }
  );
  
  const headers = await generateOhifHeaders(
    {
      hasPscTokenBearer  : ohifTransferToPacsStatusPSCTokenBearer,
      hasAuthTokenBearer : ohifTransferToPacsStatusAuthTokenBearer,
      structIdHeaderName : ohifTransferToPacsStatusStructIdNatHeaderName,
      sessionIdHeaderName: ohifTransferToPacsStatusSessionIdHeaderName,
      pacsIdHeaderName   : ohifTransferToPacsStatusPacsIdHeaderName,
      
      ohifAuthUsername,
      ohifAuthUsernameArg,
      ohifAuthPasswd,
      ohifAuthPasswdArg,
      ohifAuthUrl
    },
    s_struct_IdNat,
    defaultPacsId,
    ohifSessionId,
    pscTokenBearer
  );
  
  headers.set("Content-Type", "application/json");
  
  const options = {
    method: "GET",
    headers
  };
  
  const body = { [ohifTransferToPacsStatusTransferIdArgName]: transferId };
  url        = `${url}${url.indexOf("?") !== -1 ? "&" : "?"}${objectToQueryParams(body)}`;
  
  return fetch(
    url,
    options
  );
};
